import React, { useState, useEffect } from "react";
import "./VTChecking.css";

const VTChecking = ({ goBack, goToNext, formData, updateResistance, updatePolarity }) => {
  const selectedWinding = formData.winding;
  

  const WINDING_RESISTANCE_KEY = 'vt_winding_resistance_data';
  const POLARITY_CHECK_KEY = 'vt_polarity_check_data';
  
 
  const loadWindingResistanceFromStorage = () => {
    try {
      const storedData = localStorage.getItem(WINDING_RESISTANCE_KEY);
      if (storedData) {
        return JSON.parse(storedData);
      }
    } catch (error) {
      console.error('Error loading winding resistance from localStorage:', error);
    }
    return null;
  };

  const loadPolarityCheckFromStorage = () => {
    try {
      const storedData = localStorage.getItem(POLARITY_CHECK_KEY);
      if (storedData) {
        return JSON.parse(storedData);
      }
    } catch (error) {
      console.error('Error loading polarity check from localStorage:', error);
    }
    return null;
  };

  const [windingResistance, setWindingResistance] = useState(
    formData.windingResistance.length > 0 ? formData.windingResistance : loadWindingResistanceFromStorage() || []
  );
  
  const [polarityCheck, setPolarityCheck] = useState(
    formData.polarityCheck.length > 0 ? formData.polarityCheck : loadPolarityCheckFromStorage() || []
  );

  const unitOptions = ["Ω", "KΩ", "MΩ", "TΩ", "GΩ"];
  const polarityOptions = ["", "FORWARD", "REVERSE"];

 
  const saveWindingResistanceToStorage = (data) => {
    try {
      localStorage.setItem(WINDING_RESISTANCE_KEY, JSON.stringify(data));
    } catch (error) {
      console.error('Error saving winding resistance to localStorage:', error);
    }
  };

 
  const savePolarityCheckToStorage = (data) => {
    try {
      localStorage.setItem(POLARITY_CHECK_KEY, JSON.stringify(data));
    } catch (error) {
      console.error('Error saving polarity check to localStorage:', error);
    }
  };




useEffect(() => {
  const windingMap = {
    "1a - 1n": ["Core 1(da-dn)", "A - N"],
    "2a - 2n": ["Core 1(1a-1n)", "Core 2(da-dn)", "A - N"],
    "3a - 3n": ["Core 1(1a-1n)", "Core 2(2a-2n)", "Core 3(da-dn)", "A - N"],
    "4a - 4n": ["Core 1(1a-1n)", "Core 2(2a-2n)", "Core 3(3a-3n)", "Core 4(da-dn)", "A - N"],
    "da - dn": ["Core 1(1a-1n)", "Core 2(2a-2n)", "Core 3(3a-3n)", "Core 4(4a-4n)", "Core 5(da-dn)", "A - N"]
  };

  const polarityMap = {
    "1a - 1n": ["Core 1(da-dn)"],
    "2a - 2n": ["Core 1(1a-1n)", "Core 2(da-dn)"],
    "3a - 3n": ["Core 1(1a-1n)", "Core 2(2a-2n)", "Core 3(da-dn)"],
    "4a - 4n": ["Core 1(1a-1n)", "Core 2(2a-2n)", "Core 3(3a-3n)", "Core 4(da-dn)"],
    "da - dn": ["Core 1(1a-1n)", "Core 2(2a-2n)", "Core 3(3a-3n)", "Core 4(4a-4n)", "Core 5(da-dn)"]
  };

  const selectedWindingResistance = windingMap[selectedWinding] || [];
  const selectedPolarityCheck = polarityMap[selectedWinding] || [];


  if (!selectedWinding) {
    return;
  }

  
  const storedWindingData = loadWindingResistanceFromStorage() || [];
  const storedPolarityData = loadPolarityCheckFromStorage() || [];
  const formWindingData = formData.windingResistance || [];
  const formPolarityData = formData.polarityCheck || [];

 
  const allExistingWindingData = [...storedWindingData];
  formWindingData.forEach(item => {
    if (item && item.reference && !allExistingWindingData.find(d => d.reference === item.reference)) {
      allExistingWindingData.push(item);
    }
  });
  
 
  const normalizeReference = (ref) => {
   
    if (ref.includes('A - N')) return 'A - N';
    
  
    const coreMatch = ref.match(/Core\s+(\d+)\(([^)]+)\)/);
    if (coreMatch) {
      return `Core ${coreMatch[1]}`;
    }
    
    return ref;
  };

  const windingDataMap = new Map();
  allExistingWindingData.forEach(item => {
    if (item && item.reference) {
      const normalizedKey = normalizeReference(item.reference);
      windingDataMap.set(normalizedKey, item);
    }
  });

 
  const newWindingData = selectedWindingResistance.map((reference) => {
    const normalizedKey = normalizeReference(reference);
    

    if (windingDataMap.has(normalizedKey)) {
      const existingItem = windingDataMap.get(normalizedKey);
     
      return {
        reference: reference,
        rPh: existingItem.rPh || { value: "", unit: "Ω" },
        yPh: existingItem.yPh || { value: "", unit: "Ω" },
        bPh: existingItem.bPh || { value: "", unit: "Ω" }
      };
    }
    

    return {
      reference: reference,
      rPh: { value: "", unit: "Ω" },
      yPh: { value: "", unit: "Ω" },
      bPh: { value: "", unit: "Ω" }
    };
  });

  setWindingResistance(newWindingData);
  saveWindingResistanceToStorage(newWindingData);


  const allExistingPolarityData = [...storedPolarityData];
  formPolarityData.forEach(item => {
    if (item && item.reference && !allExistingPolarityData.find(d => d.reference === item.reference)) {
      allExistingPolarityData.push(item);
    }
  });


  const polarityDataMap = new Map();
  allExistingPolarityData.forEach(item => {
    if (item && item.reference) {
      const normalizedKey = normalizeReference(item.reference);
      polarityDataMap.set(normalizedKey, item);
    }
  });


  const newPolarityData = selectedPolarityCheck.map((reference) => {
    const normalizedKey = normalizeReference(reference);
    

    if (polarityDataMap.has(normalizedKey)) {
      const existingItem = polarityDataMap.get(normalizedKey);
     
      return {
        reference: reference,
        rPh: existingItem.rPh || "",
        yPh: existingItem.yPh || "",
        bPh: existingItem.bPh || ""
      };
    }
    

    return {
      reference: reference,
      rPh: "",
      yPh: "",
      bPh: ""
    };
  });

  setPolarityCheck(newPolarityData);
  savePolarityCheckToStorage(newPolarityData);
  
}, [selectedWinding, formData.winding]);

  useEffect(() => {
    if (windingResistance.length > 0) {
      saveWindingResistanceToStorage(windingResistance);
    }
  }, [windingResistance]);

 
  useEffect(() => {
    if (polarityCheck.length > 0) {
      savePolarityCheckToStorage(polarityCheck);
    }
  }, [polarityCheck]);

 
  useEffect(() => {
    return () => {
      saveWindingResistanceToStorage(windingResistance);
      savePolarityCheckToStorage(polarityCheck);
    };
  }, [windingResistance, polarityCheck]);


  const validateNumericInput = (value) => {
    const numericValue = value.replace(/[^0-9.<>]/g, '');
    const parts = numericValue.split('.');
    if (parts.length > 2) {
      return parts[0] + '.' + parts.slice(1).join('');
    }
    return numericValue;
  };

  const handleWindingChange = (index, phase, field, value) => {
    const updated = [...windingResistance];
    
    if (field === "value") {
      value = validateNumericInput(value);
    }
    
    updated[index][phase][field] = value;
    setWindingResistance(updated);
  };

  const handlePolarityChange = (index, phase, value) => {
    const updated = [...polarityCheck];
    updated[index][phase] = value;
    setPolarityCheck(updated);
  };

  const clearAllStoredData = () => {
    try {
      localStorage.removeItem(WINDING_RESISTANCE_KEY);
      localStorage.removeItem(POLARITY_CHECK_KEY);
      
      
      const windingMap = {
        "1a - 1n": ["Core 1(da-dn)", "A - N"],
        "2a - 2n": ["Core 1(1a-1n)", "Core 2(da-dn)", "A - N"],
        "3a - 3n": ["Core 1(1a-1n)", "Core 2(2a-2n)", "Core 3(da-dn)", "A - N"],
        "4a - 4n": ["Core 1(1a-1n)", "Core 2(2a-2n)", "Core 3(3a-3n)", "Core 4(da-dn)", "A - N"],
        "da - dn": ["Core 1(1a-1n)", "Core 2(2a-2n)", "Core 3(3a-3n)", "Core 4(4a-4n)", "Core 5(da-dn)", "A - N"]
      };

      const polarityMap = {
        "1a - 1n": ["Core 1(da-dn)"],
        "2a - 2n": ["Core 1(1a-1n)", "Core 2(da-dn)"],
        "3a - 3n": ["Core 1(1a-1n)", "Core 2(2a-2n)", "Core 3(da-dn)"],
        "4a - 4n": ["Core 1(1a-1n)", "Core 2(2a-2n)", "Core 3(3a-3n)", "Core 4(da-dn)"],
        "da - dn": ["Core 1(1a-1n)", "Core 2(2a-2n)", "Core 3(3a-3n)", "Core 4(4a-4n)", "Core 5(da-dn)"]
      };

      const selectedWindingResistance = windingMap[selectedWinding] || [];
      const selectedPolarityCheck = polarityMap[selectedWinding] || [];
      
      const defaultWindingData = selectedWindingResistance.map((reference) => ({
        reference: reference,
        rPh: { value: "", unit: "Ω" },
        yPh: { value: "", unit: "Ω" },
        bPh: { value: "", unit: "Ω" }
      }));
      
      const defaultPolarityData = selectedPolarityCheck.map((reference) => ({
        reference: reference,
        rPh: "",
        yPh: "",
        bPh: ""
      }));
      
      setWindingResistance(defaultWindingData);
      setPolarityCheck(defaultPolarityData);
    } catch (error) {
      console.error('Error clearing stored data:', error);
    }
  };

const redirectToHome = () => {
  if (window.confirm("Are you sure you want to leave this page? Any unsaved changes will be lost.")) {  
    localStorage.setItem('openReportsOnLoad', 'true');
    window.location.href = "/";
  }
};

  const handleSubmit = (e) => {
    e.preventDefault();
    
    saveWindingResistanceToStorage(windingResistance);
    savePolarityCheckToStorage(polarityCheck);
    
    updateResistance(windingResistance);
    updatePolarity(polarityCheck);
    goToNext();
  };

  return (
    <form onSubmit={handleSubmit} className="V-checking-form">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <div>
          
        </div>
        
        <span 
          style={{ 
            display: 'flex',
            justifyContent: 'flex-end',
            fontSize: '20px', 
            fontWeight: '600', 
            color: '#333', 
            cursor: 'pointer'
          }}
          onClick={redirectToHome}
        >
          X
        </span>
      </div>
        
      <div className="V-section">
        <h3>WINDING RESISTANCE</h3>
        
        <div className="V-grid-container">
          <div className="V-grid-row V-header-row">
            <div className="V-grid-cell V-reference-header">Reference <span className="span">*</span></div>
            <div className="V-grid-cell V-measure-header" colSpan={3}>
              Measured Resistance Ω <span className="span">*</span>
            </div>
          </div>
          
          <div className="V-grid-row V-sub-header-row">
            <div className="V-grid-cell V-reference-header"></div>
            <div className="V-grid-cell V-phase-header">R - ph</div>
            <div className="V-grid-cell V-phase-header">Y - ph</div>
            <div className="V-grid-cell V-phase-header">B - ph</div>
          </div>
          
          {windingResistance.map((item, i) => (
            <div className="V-grid-row" key={i}>
              <div className="V-grid-cell V-reference-cell">
                <input
                  type="text"
                  value={item.reference || ""}
                  readOnly
                  className="reference-input"
                  style={{
                  
                    border: '1px solid #ccc',
                    cursor: 'not-allowed',
                    color: '#666',
                    
                    padding: '8px',
                    borderRadius: '4px',
                    fontWeight: 'bold'
                  }}
                />
              </div>
              
              <div className="V-grid-cell">
                <div className="input-unit-container">
                  <input
                    className="resistance-input"
                    value={item.rPh?.value || ""}
                    maxLength={10}
                    placeholder="Enter R - ph"
                    onChange={(e) => handleWindingChange(i, "rPh", "value", e.target.value)}
                    inputMode="decimal"
                  />
                  <select
                    className="unit-select"
                    value={item.rPh?.unit || "Ω"}
                    onChange={(e) => handleWindingChange(i, "rPh", "unit", e.target.value)}
                  >
                    {unitOptions.map((unit) => (
                      <option key={unit} value={unit}>
                        {unit}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              
              <div className="V-grid-cell">
                <div className="input-unit-container">
                  <input
                    className="resistance-input"
                    value={item.yPh?.value || ""}
                    maxLength={10}
                    placeholder="Enter Y - ph"
                    onChange={(e) => handleWindingChange(i, "yPh", "value", e.target.value)}
                    inputMode="decimal"
                  />
                  <select
                    className="unit-select"
                    value={item.yPh?.unit || "Ω"}
                    onChange={(e) => handleWindingChange(i, "yPh", "unit", e.target.value)}
                  >
                    {unitOptions.map((unit) => (
                      <option key={unit} value={unit}>
                        {unit}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              
              <div className="V-grid-cell">
                <div className="input-unit-container">
                  <input
                    className="resistance-input"
                    value={item.bPh?.value || ""}
                    maxLength={10}
                    placeholder="Enter B - ph"
                    onChange={(e) => handleWindingChange(i, "bPh", "value", e.target.value)}
                    inputMode="decimal"
                  />
                  <select
                    className="unit-select"
                    value={item.bPh?.unit || "Ω"}
                    onChange={(e) => handleWindingChange(i, "bPh", "unit", e.target.value)}
                  >
                    {unitOptions.map((unit) => (
                      <option key={unit} value={unit}>
                        {unit}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="V-section">
        <h3>POLARITY CHECK</h3>
        
        <div className="V-grid-container">
          <div className="V-grid-row V-header-row">
            <div className="V-grid-cell V-reference-header">Reference <span className="span">*</span></div>
            <div className="V-grid-cell V-measure-header" colSpan={3}>
              Polarity Direction <span className="span">*</span>
            </div>
          </div>
          
          <div className="V-grid-row V-sub-header-row">
            <div className="V-grid-cell V-reference-header"></div>
            <div className="V-grid-cell V-phase-header">R - ph</div>
            <div className="V-grid-cell V-phase-header">Y - ph</div>
            <div className="V-grid-cell V-phase-header">B - ph</div>
          </div>
          
          {polarityCheck.map((item, i) => (
            <div className="V-grid-row" key={i}>
              <div className="V-grid-cell V-reference-cell">
                <input
                  type="text"
                  value={item.reference || ""}
                  readOnly
                  className="reference-input"
                  style={{
                    
                    border: '1px solid #ccc',
                    cursor: 'not-allowed',
                    color: '#666',
                    
                    padding: '8px',
                    borderRadius: '4px',
                    fontWeight: 'bold'
                  }}
                />
              </div>
              
              <div className="V-grid-cell">
                <select
                  className="polarity-select"
                  value={item.rPh || ""}
                  onChange={(e) => handlePolarityChange(i, "rPh", e.target.value)}
                >
                  {polarityOptions.map((option) => (
                    <option key={option} value={option}>
                      {option === "" ? "Select R - ph" : option}
                    </option>
                  ))}
                </select>
              </div>
              
              <div className="V-grid-cell">
                <select
                  className="polarity-select"
                  value={item.yPh || ""}
                  onChange={(e) => handlePolarityChange(i, "yPh", e.target.value)}
                >
                  {polarityOptions.map((option) => (
                    <option key={option} value={option}>
                      {option === "" ? "Select Y - ph" : option}
                    </option>
                  ))}
                </select>
              </div>
              
              <div className="V-grid-cell">
                <select
                  className="polarity-select"
                  value={item.bPh || ""}
                  onChange={(e) => handlePolarityChange(i, "bPh", e.target.value)}
                >
                  {polarityOptions.map((option) => (
                    <option key={option} value={option}>
                      {option === "" ? "Select B - ph" : option}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="V-button-group">
        <button type="button" onClick={goBack}>Back</button>
        <button type="submit">Next</button>
      </div>
    </form>
  );
};

export default VTChecking;